import { getAppUrl } from "./getAppUrl";

const EMAIL_VERIFY_SENT_PATH = "/welcome/login/linkVerify";

export const getLoginUrl = (email: string): string => {
  const appDomain = getAppUrl();
  try {
    const loginUrl = new URL(EMAIL_VERIFY_SENT_PATH, appDomain);

    // FIXME: We have avoided using URL constructor with search params here because the email login link doesn't work when encoded.
    // We should review API logic to address this issue.
    // https://linear.app/clipboardhealth/issue/FEF-80/investigate-request-login-link-api-encoding-issues
    return `${loginUrl.toString()}?email=${email}`;
  } catch (error) {
    throw new Error(
      `Problem creating login URL for appDomain: ${appDomain}. Original error: ${String(error)}`
    );
  }
};
